import type { Actor } from "./types.ts";

/** An actor with no assigned projects works in every project, including future ones. A missing list (untyped data) is not "all": it fails closed. */
export function actorInProject(actor: Pick<Actor, "projectIds">, projectId: string): boolean {
  if (!Array.isArray(actor.projectIds)) return false;
  return actor.projectIds.length === 0 || actor.projectIds.includes(projectId);
}
